var map = {
	"./1.png": 6634,
	"./2.png": 7217,
	"./3.png": 9736,
	"./4.jpg": 151,
	"./77.jpeg": 7702,
	"./88.jpeg": 540,
	"./About-IMG1.png": 9973,
	"./About-IMG2.png": 8174,
	"./About-IMG3.png": 1191,
	"./About-Us.jpg": 2911,
	"./Banner-IMG.png": 6363,
	"./Blog-2.png": 8466,
	"./Blog-3.png": 2683,
	"./Blog.jpg": 4847,
	"./Blog1.png": 5670,
	"./Header-bg.png": 4442,
	"./IMG-1.png": 1004,
	"./IMG-2.png": 9735,
	"./IMG-3.png": 6094,
	"./IMG-4.png": 2833,
	"./IMG-5.png": 120,
	"./IMG-6.png": 4611,
	"./IMG-7.png": 3850,
	"./IMG22.jpg": 2802,
	"./TokoYarn-Black-Logo.png": 5528,
	"./about.jpg": 8296,
	"./blog_detail.png": 9131,
	"./blog_detais'.png": 6489,
	"./contact-banner.jpg": 6184,
	"./contact-bg.jpg": 3479,
	"./digital.jpg": 251,
	"./favicon.ico": 804,
	"./footer-img.webp": 6108,
	"./img1.png": 7725,
	"./img2.png": 6518,
	"./img3.png": 5535,
	"./login-form.jpg": 7841,
	"./login.png": 9340,
	"./logistics.jpg": 2790,
	"./logo-dark-old.png": 6937,
	"./logo-dark.png": 9949,
	"./logo-dark1.png": 4368,
	"./logo-footer.png": 9176,
	"./logo-light.png": 197,
	"./logo192.png": 3864,
	"./national.jpg": 4393,
	"./register.png": 6656,
	"./section-image1.jpg": 5649,
	"./section-image2.jpg": 6038,
	"./section-image3.jpg": 7651,
	"./section-image4.jpg": 7344,
	"./seller-bg.jpg": 5184,
	"./trade.jpg": 9497,
	"./why_choose.jpg": 4181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;